// extracted by mini-css-extract-plugin
export default {"header":"Q4T8JH","title":"qJU_n_","close-button":"yCVhgt","closeButton":"yCVhgt"};